if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.productId = this.form.querySelector('[name="product-id"]').value;
        this.variantsMetafieldsJsonElement = document.getElementById(`VariantsMetafieldsJson-${this.productId}`);
        if (this.variantsMetafieldsJsonElement) this.variantsMetafieldsJson = JSON.parse(this.variantsMetafieldsJsonElement.textContent);
        this.quantityElement = document.getElementById(`Quantity-Form-${this.sectionId}`); 
        this.quantityInput = this.quantityElement?.querySelector('.quantity__input');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.submitButtonPrice = this.submitButton.querySelector('.product__price');
        this.regularPriceElement = this.submitButtonPrice?.querySelector('.price__regular .price-item--regular');
        this.salePriceElement = this.submitButtonPrice?.querySelector('.price__sale .price-item--sale');

        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      quantityUpdateUnsubscriber = undefined;

      connectedCallback() {
        this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.onQuantityChanged.bind(this));
      }

      disconnectedCallback() {
        if (this.quantityUpdateUnsubscriber) {
          this.quantityUpdateUnsubscriber();
        }
      }

      onQuantityChanged(event) {  
        const quantity = event?.data.quantity || this.quantityInput?.value || 1;
        
        this.updateSubmitButtonPrices(quantity);
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        const currentVariantId = parseInt(this.variantIdInput.value);
        const currentVariantMetafieldsJson = this.variantsMetafieldsJson?.find((variant) => variant.id === currentVariantId);
        const quantity = this.quantityInput?.value || 1;
        let isPreorder = false;
        
        if ((currentVariantMetafieldsJson && currentVariantMetafieldsJson.preorder === true) || this.submitButton.dataset.preOrder === 'true') {
          isPreorder = true;
        }
        
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          if (!isPreorder) {
            this.submitButtonText.textContent = window.variantStrings.addToCart;
          } else {
            this.submitButtonText.textContent = window.variantStrings.preOrder;
          }          
        }
  
        this.updateSubmitButtonPrices(quantity);
      }

      updateSubmitButtonPrices(quantity) {
        if (this.submitButtonPrice === null) return;

        const currentVariant = this.variantData;
        const price = currentVariant.price * quantity;
        
        if (this.regularPriceElement) {
          this.regularPriceElement.textContent = formatPrice(price);
          this.regularPriceElement.dataset.price = price;
        }
        if (this.salePriceElement) {
          this.salePriceElement.textContent = formatPrice(price);
          this.salePriceElement.dataset.price = price;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

      get variantData() {
        return JSON.parse(document.getElementById(`SelectedVariantJson-${this.productId}`)?.textContent);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}
